import TwoToOneGrid from './TwoToOneGrid'

export default TwoToOneGrid
